import apiPaths from '../api-paths';

export default {
  downloadMailAttachement(mailOriginalId, downloadToken) {
    const urlEncodedToken = encodeURIComponent(downloadToken);

    return axios.get(`${ apiPaths.API }/mail-attachments/${mailOriginalId}/${urlEncodedToken}`, {
      responseType: 'blob',
    });
  },
};
